import theme from "../../../style/theme";
import { CoordinatePin } from "./CoordinatePin";
import { CoordinatePinProps } from "./coordinate-pin-props";
import { rgba } from "polished";

export const BlackCoordinatePin: React.FC<CoordinatePinProps> = ({
    memberName,
    title,
    leftBody,
    leftBodyColor,
    rightBody,
    footer,
    positionStyle,
    id,
    ...rest
}) => {
    return (
        <CoordinatePin
            backgroundColor={rgba(theme.palette.primitives.black, 0.8)}
            hoverBackgroundColor={theme.palette.primitives.yellow400}
            color={theme.palette.primitives.white}
            hoverColor={theme.palette.primitives["black"]}
            memberName={memberName}
            title={title}
            leftBody={leftBody}
            leftBodyColor={leftBodyColor}
            rightBody={rightBody}
            footer={footer}
            positionStyle={positionStyle}
            id={id}
            {...rest}
        />
    );
};
